import React, { FunctionComponent, useContext, useEffect } from "react";
import { API } from "../../../../api";
import { AppStore } from "../../../../AppStore";
import { WebSocketContext } from "../../../../providers/WebSocketProvider";
import styles from "../styles/EventsDashboard.css";
import Body from "./Body";

interface Props {}

const EventsDashboard: FunctionComponent<Props> = () => {

    return (
        <div className={styles.bodyContainer} >
            <Body />
        </div>
    )
}

export default EventsDashboard;